import { ReduxState } from "@dashboard/types";

export const DefaultFeatureFlags: ReduxState["dashboardApp"]["featureFlags"] = {
  allowManualAllergensAndPreferences: false,
  allowSettingSpiceLevel: false,
  allowDishDeleteWithoutConfirmation: false,
  allowUploadingDishImages: false,
  allowHidingDish: false,
  allowCsvImportExport: false,
  showDisclaimers: false,
  showQuickAddDish: false,
  showIds: false,
  showIntegrationsPage: false,
  allowSupplierInfoEntry: false,
};
